module.exports = __webpack_public_path__ + "img/SET-m.3b7419bf.png";